import { useAppSelector } from '@hooks/app/redux';
import { getPendingActionsProfile } from '@services/external/pendingActions.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ACTION_NAMES } from './pendingActions.utils';

async function handler(providerId: string) {
  const { data } = await getPendingActionsProfile(providerId);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function usePendingActionsBusinessProfile(
  options?: UseQueryOptions<TQueryData | null, unknown, TQueryData, any>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery([ACTION_NAMES.businessProfile, providerId], () => handler(providerId), {
    ...options,
    enabled: options?.enabled ?? !!providerId,
  });
}

export default usePendingActionsBusinessProfile;
